import { message, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { WarningTwoTone } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cancelBooking } from '@/common/http/meet';
import { isSuccessCode } from '@/common/utils/response';
import { TStore } from '@/common/basis/types/tstore';
import {
  setCancelRoomId,
  setDetailRoomId,
  setIsHandBookingSuccess,
  setIsOpenBookingDetail,
  setIsOpenCannelMeeting,
} from '@/common/store/booking/slice';

function App() {
  const dispatch = useDispatch();
  const isOpenBookingDetail = useSelector((state: TStore.State) => state.booking.isOpenBookingDetail);
  const isOpenCannelMeeting = useSelector((state: TStore.State) => state.booking.isOpenCannelMeeting);
  const cancelRoomId = useSelector((state: TStore.State) => state.booking.cancelRoomId);
  const [isOkLoading, setIsOkLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage({ top: 60 });
  const { t } = useTranslation();

  // 取消会议
  const requestCancelBooking = async () => {
    if (isOkLoading) {
      return;
    }
    if (!cancelRoomId) {
      return;
    }

    setIsOkLoading(true);
    try {
      const resp = await cancelBooking({ roomId: [cancelRoomId] });

      if (isSuccessCode(resp.code)) {
        if (isOpenBookingDetail) {
          dispatch(setIsOpenBookingDetail(false));
          dispatch(setDetailRoomId(''));
        }
        dispatch(setIsOpenCannelMeeting(false));
        dispatch(setIsHandBookingSuccess(true));
      } else {
        messageApi.error(t('cancelMeetingFail'));
      }
    } catch (err) {
      // TOOD
    }
    setIsOkLoading(false);
  };

  useEffect(() => {
    if (!isOpenCannelMeeting) {
      messageApi.destroy();
      dispatch(setCancelRoomId(''));
    }
  }, [isOpenCannelMeeting]);

  return (
    <>
      <Modal
        cancelText={t('cancel')}
        okButtonProps={{ loading: isOkLoading }}
        okText={t('confirm')}
        onCancel={() => dispatch(setIsOpenCannelMeeting(false))}
        onOk={() => requestCancelBooking()}
        open={isOpenCannelMeeting}
        title={t('warmTips')}
        width={360}
      >
        <div className='flex items-center justify-start px-5 py-5'>
          <WarningTwoTone className='mr-2 text-[18px]' />
          <span>{t('cancelMeetingTip')}</span>
        </div>
      </Modal>
      {contextHolder}
    </>
  );
}

export default App;
